import { render, staticRenderFns } from "./error_question.vue?vue&type=template&id=3c2f2a48&scoped=true&"
import script from "./error_question.vue?vue&type=script&lang=js&"
export * from "./error_question.vue?vue&type=script&lang=js&"
import style0 from "./error_question.vue?vue&type=style&index=0&id=3c2f2a48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f2a48",
  null
  
)

export default component.exports